<script>
import { VAutocomplete } from 'vuetify/lib'
import inputMixin from './mixin_input'
export default {
	extends: VAutocomplete,
	mixins: [inputMixin],
}
</script>
